// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"5824":"663a4263","8951":"ca19e2b2"}[chunkId] + ".css";
};